import React from "react";
import { Switch } from "@headlessui/react";
import classNames from "classnames";
import FormControlLabel from '@mui/material/FormControlLabel'
import MUISwitch from '@mui/material/Switch'

export const SwitchInput = ({
  label,
  on,
  name,
  disabled,
  onChange,
  labelPosition = "top",
  gxid,
}) => {
  return (
    <div
      className={classNames(
        labelPosition === "left" ? "inline-flex items-center gap-5" : "",
        labelPosition === "right"
          ? "inline-flex flex-row-reverse items-center gap-5"
          : ""
      )}
    >
      {label.length > 0 && (
        <label
          htmlFor={name}
          className={classNames(
            labelPosition !== "top" ? "" : "mb-1",
            `block  font-semibold text-sm`
          )}
        >
          {label}
        </label>
      )}
      <Switch
        data-gxid={gxid}
        disabled={disabled}
        name={name}
        label={label}
        checked={on}
        onChange={(v) => onChange(v)}
        className={classNames(
          on ? "bg-blue-dark" : "bg-gray-300",
          disabled ? "cursor-not-allowed" : "",
          "relative inline-flex h-[16px] w-[40px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75"
        )}
      >
        <span className="sr-only">Use setting</span>
        <span
          aria-hidden="true"
          className={classNames(
            on
              ? "translate-x-5 bg-blue-dark"
              : "translate-x-0 bg-white border border-gray-200",
            "pointer-events-none scale-150 inline-block h-[16px] w-[16px] transform rounded-full shadow-sm ring-0 transition duration-200 ease-in-out -mt-0.5"
          )}
        />
      </Switch>
    </div>
  );
};


export const MUISwitchInput = ({
  label,
  on,
  name,
  disabled,
  onChange,
  labelPosition = "right",
  gxid,
}) => {
  return (
    <FormControlLabel
      control={
        <MUISwitch
          checked={on}
          onChange={(e) => onChange(e.target.checked)}
          color="primary"
          disabled={disabled}
          name={name}
          inputProps={{ 'data-gxid': gxid }}
        />
      }
      label={label}
      labelPlacement={labelPosition === "left" ? "start" : labelPosition === "right" ? "end" : "top"}
    />
  )
}